import Vue from 'vue';

// initial state
const state = {
  counter: 0,
  edo: {
    firstName: "",
    lastName: "",
    email: "",
    message: "",
    postcode: "",
    phoneNumber: "",
  }
};

const getters = {
  counter: function (state) {
    return state.counter;
  },
  edo: function (state) {
    return state.edo;
  }
};

const mutations = {
  setCounter: function (state, counter) {
    state.counter = counter;
  }
};

const actions = {
  getCounterByCampaignId: function (context, campaignId) {
    Vue.http.get(`${wwfconfigs.WEB_API}/campaign/counter?campaignId=${campaignId}`).then(response => {
      context.commit('setCounter', response.body.count);
    });
  },
  getContentMessageById: function (context, id) {
    return Vue.http.get(`${wwfconfigs.WEB_API}/campaign/message?messageId=${id}`).then(response => response.body);
  },
  saveLead: function (context, data) {
    data = {
      ...data
    };
    return Vue.http.post(`${wwfconfigs.WEB_API}/campaign/lead`, data);
  },
  saveSignature: function (context, data) {
    return Vue.http.post(`${wwfconfigs.WEB_API}/campaign/signatures`, data);
  },
  savePartnershipForm: function (context, data) {
    return Vue.http.post(`${wwfconfigs.WEB_API}/partnership/create`, data);
  },
  checkEmail: function (context, data) {
    if (!data.email || data.email.length === 0 || !data.email.includes('@')) {
      return false;
    }

    // Check if the mail already exist for this particular campaign
    return Vue.http.post(`${wwfconfigs.WEB_API}/campaign/check-email?campaignId=${data.campaignId}&email=${data.email}`)
      .then(response => {
        return response.body.exist;
      },
        error => {
          console.error(error);
          return false;
        }
      );
  },
  getEPBCRecipients: function (context, data) {
    return Vue.http.get(`${wwfconfigs.WEB_API}/campaign/epbc/recipients?postcode=${data.postcode}`)
      .then(response => {
        return response.body;
      },
        error => {
          console.error(error);
          return false;
        }
      );
  },
  uploadEarthhourLogo: function (context, data) {
    return Vue.http.post(`${wwfconfigs.WEB_API}/earth-hour/upload-logo?organisationName=${data.organisationName}`, data.file)
      .then(response => {
        return response.body.url;
      }, error => {
        console.error(error);
      });
  },
  createEarthhourLogo: function (context, data) {
    return Vue.http.post(`${wwfconfigs.WEB_API}/earth-hour/logos`, data)
      .then(response => {
        return response.body;
      }, error => {
        console.error(error);
      });
  },
  getEarthHourLogos: function (context, { page, size, section }) {
    return Vue.http.get(`${wwfconfigs.WEB_API}/earth-hour/logos?page=${page}&size=${size}${section ? `&section=${section}` : ''}`)
      .then(response => {
        return response.body;
      }, error => {
        console.error(error);
      });
  },
  purifyText: function (context, text) {
    const endPoint = 'https://api1.webpurify.com/services/rest';
    const apiKey = 'b7c6af7e5259ce74f099897deb9dcf29';
    const url = `${endPoint}?api_key=${apiKey}&text=${encodeURIComponent(text)}&method=webpurify.live.check&format=json`;
    return Vue.http.jsonp(url).then((response) => {
      if (response.data) {
        if (response.data.rsp.found == "0") {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }, (error) => {
      console.error(error);
      return true;
    });
  },
  uploadEDOVideo: function (context, data) {
    return Vue.http.post(`${wwfconfigs.WEB_API}/campaign/edo/videos`, data)
      .then(response => {
        return response.body.url;
      }, error => {
        console.error(error);
      });
  },
  createFile: function (context, data) {
    return Vue.http.post(`${wwfconfigs.WEB_API}/campaign/files`, data)
      .then(response => {
        return response.body;
      }, error => {
        console.error(error);
      });
  },
  getFeatureSwitch({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${wwfconfigs.WEB_API}/setting?settingId=${id}`,).then(response => {
        const setting = response.body;
        resolve(!!setting ? setting.value : true);
      }, error => {
        console.error("getFeatureSwitch", error);
        reject(error);
      });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/campaign.js